import { IObservable, Subject } from '~/rage/utils';
import { CharacterSkill, getRandomInt } from '~/shared';
import {
	ICharacterSkillLevel,
	ICharacterSkillsService,
} from './characterSkillsServiceTypes';

export class CharacterSkillsServiceStub implements ICharacterSkillsService {
	private maxExpBySkillLevel: Map<string, number> = new Map();

	private skillLevels: Record<CharacterSkill, Subject<ICharacterSkillLevel>> =
		Object.values(CharacterSkill).reduce(
			(acc, skill) => {
				acc[skill] = new Subject<ICharacterSkillLevel>({
					level: getRandomInt(1, 2),
					maxLevel: getRandomInt(3, 4),
					exp: getRandomInt(0, 50),
					maxExp: getRandomInt(50, 100),
				});
				return acc;
			},
			{} as Record<CharacterSkill, Subject<ICharacterSkillLevel>>,
		);

	constructor() {
		for (const skill of Object.values(CharacterSkill)) {
			for (let i = 1; i <= 4; i++) {
				this.maxExpBySkillLevel.set(`${skill}_${i}`, 100 * i);
			}

			const skillLevelSubj = this.skillLevels[skill];
			const skillLevel = skillLevelSubj.getValue();
			const maxExp = this.calculateNextLevelSkillExp(skill, skillLevel.level);
			skillLevelSubj.next({ ...skillLevel, maxExp });
		}
	}

	private calculateNextLevelSkillExp(
		skill: CharacterSkill,
		level: number,
	): number {
		return this.maxExpBySkillLevel.get(`${skill}_${level + 1}`) ?? 100;
	}

	public getSkillLevel(
		skill: CharacterSkill,
	): IObservable<ICharacterSkillLevel> {
		return this.skillLevels[skill];
	}
}
